import { AgeRate } from '../../common';

const ageRateViewModel: Record<AgeRate, string> = {
  [AgeRate.FAMILY]: 'FAMILY',
  [AgeRate.PG]: 'PG',
  [AgeRate.Fifteen]: 'PG 15',
  [AgeRate.Eighteen]: '18',
  [AgeRate.PG15]: 'PG 15',
  [AgeRate.Sixteen]: 'PG 16',
  [AgeRate.SixteenD]: 'PG 16D',
  [AgeRate.EighteenR]: '18 R',
  [AgeRate.R]: 'R',
};

export const mapAgeRateDomainToViewModel = (ageRate: AgeRate): string => {
  return ageRateViewModel[ageRate];
};
